// extracted by mini-css-extract-plugin
export default {"labelWithBackgroundContainer":"AXvxQ","labelComponent":"MLSqu","pictoUrl":"W8xoH","exposant":"huqe5"};